import { countCountries, useLiveBusinesses } from '@/hooks/useLiveBusinesses';

export interface CatalogueStats {
  operators: number;
  countries: number;
  wildlife: number;
  adventure: number;
}

/**
 * Live size of the catalogue (operators, countries, wildlife/adventure split) for honest copy.
 * Returns null while loading or if the API fails, so callers fall back to count-free text.
 * Shares one request with the For business page via useLiveBusinesses, so the numbers agree.
 */
export function useCatalogueStats(): CatalogueStats | null {
  const live = useLiveBusinesses();
  if (live.state !== 'ready') return null;
  const { list } = live;
  return {
    operators: list.length,
    countries: countCountries(list),
    wildlife: list.filter(b => b.hasAnimalActivities).length,
    adventure: list.filter(b => b.hasAdventureActivities).length,
  };
}
